import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`In 2019, the United Nations World Food Programme (WFP) continued to work hard to achieve a world free from hunger, assisting nearly 100 million people in more than 80 countries. The European Union (EU) has remained one of our most vital partners, building on past achievements to continue saving and changing millions of lives and further narrow the gap to Zero Hunger.`}</strong></p>
    <p>{`Today, some 690 million people – 8.9 percent of the global population – do not have enough to eat. The latest `}<a parentName="p" {...{
        "href": "https://www.wfp.org/publications/2020-global-report-food-crises"
      }}>{`Global Report on Food Crises`}</a>{` revealed that of these, 135 million people faced acute hunger last year. This is the highest level of severe food insecurity and malnutrition documented since the first edition of the report in 2017.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      